import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React from "react";
import Typography from "@mui/material/Typography";
import authService from "../services/AuthService";
import headerIcon from "../images/bracken_icon.svg";
import styles from "../styles/Header.module.scss";
import { useNavigate } from "react-router-dom";

interface Features {
  key: string;
  name: string;
  path: string;
}

export const Header = () => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );
  const navigate = useNavigate();
  const navItems: Features[] = [
    {
      key: "report",
      name: "Reports",
      path: "/report",
    },
    { key: "manage", name: "Manage", path: "/manage" },
    { key: "profiles", name: "Profiles", path: "/profiles"},
    { key: "providers", name: "Providers", path: "/providers" },
  ];

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <>
      <Box
        component="img"
        sx={{
          display: { xs: "none", md: "flex" },
          mr: 1,
        }}
        className={styles.headerIcon}
        alt="admin portal"
        src={headerIcon}
      />
      <Typography
        variant="h6"
        noWrap
        sx={{
          mr: 3,
          display: { xs: "none", md: "flex" },
          fontFamily: "monospace",
          fontWeight: "500",
          letterSpacing: ".1rem",
          color: "inherit",
          textDecoration: "none",
        }}
      >
        Admin Portal
      </Typography>
      <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
        <IconButton
          size="large"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleOpenNavMenu}
          color="inherit"
        >
          <MenuIcon />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorElNav}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          open={Boolean(anchorElNav)}
          onClose={handleCloseNavMenu}
          sx={{
            display: { xs: "block", md: "none" },
          }}
        >
          {navItems.map((item) => (
            <MenuItem key={item.key} onClick={handleCloseNavMenu}>
              <Typography
                textAlign="center"
                onClick={() => handleNavigate(item.path)}
              >
                {item.name}
              </Typography>
            </MenuItem>
          ))}
        </Menu>
      </Box>
      <Box
        component="img"
        className={styles.headerIcon}
        sx={{
          display: { xs: "flex", md: "none" },
          mr: 1,
        }}
        alt="admin portal"
        src={headerIcon}
      />
      <Typography
        variant="h5"
        noWrap
        sx={{
          mr: 3,
          display: { xs: "flex", md: "none" },
          flexGrow: 1,
          fontFamily: "monospace",
          fontWeight: "500",
          letterSpacing: ".1rem",
          color: "inherit",
          textDecoration: "none",
        }}
      >
        Admin Portal
      </Typography>
      <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
        {navItems.map(({ key, path, name }) => (
          <Button
            key={key}
            sx={{ color: "#fff" }}
            onClick={() => handleNavigate(path)}
          >
            {name}
          </Button>
        ))}
      </Box>
      <Box sx={{ flexGrow: 0 }}>
        <Button
          onClick={() => authService.logout()}
          size="small"
          variant="outlined"
          sx={{ color: "#fff", border: "unset" }}
        >
          Log out
        </Button>
      </Box>
    </>
  );
};
